import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to handle dashboard events like card additions
 * Allows communication between components that add cards and the dashboard itself
 */
@Injectable({
  providedIn: 'root',
})
export class AiDashboardEventsService {
  // Event emitted when a new card is added to the dashboard
  private _cardAddedSubject = new Subject<void>();
  public cardAdded$ = this._cardAddedSubject.asObservable();

  /**
   * Notify that a new card has been added to the dashboard
   * This will trigger a reload in the dashboard component if it's currently active
   */
  notifyCardAdded(): void {
    this._cardAddedSubject.next();
  }
}
